export default __webpack_public_path__ + "static/svg-sprite-f682f2b76eea767ef4b207204bda2a3a.svg";